import React from 'react'
import ProductMasonry from '../productMasonry/ProductMasonry'
import DifficultyIntensityFilters from '../productFilters/DifficultyIntensityFilters'

import { loadProductsPage } from '../../../redux/actions/products/products'
import { products } from '../../../redux/selectors/products'

import { connect } from 'react-redux'
import PropTypes from 'prop-types'

class ProductsDisplay extends React.Component {
  hasMoreProducts() {
    return this.props.products && this.props.products.length < this.props.total
  }

  paginate() {
    if (!this.props.isLoading && this.hasMoreProducts()) {
      this.props.loadProductsPage(false)
    }
  }

  render() {
    return (
      <div className='ProductDisplay'>
        <div className='ProductDisplay__masonry'>
          <ProductMasonry
            layout={this.props.layout}
            products={this.props.products}
            hasMore={this.hasMoreProducts.bind(this)}
            loading={this.props.isLoading}
            isInitialLoad={this.props.isInitialLoad}
            onPaginate={this.paginate.bind(this)}
            onAfterProductLoad={this.props.onAfterProductLoad}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    products: products(state),
    hasErrored: state.ui.products.hasErrored,
    isLoading: state.ui.products.isLoading,
    isInitialLoad: state.ui.products.isInitialLoad
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadProductsPage: (reloadAll, callback) =>
      dispatch(loadProductsPage(reloadAll, callback))
  }
}

ProductsDisplay.propTypes = {
  baseUrl: PropTypes.string,
  category: PropTypes.string,
  difficulty: PropTypes.string,
  loadProductsPage: PropTypes.func,
  group: PropTypes.string,
  isInitialLoad: PropTypes.bool,
  intensity: PropTypes.string,
  isLoading: PropTypes.bool,
  onAfterProductLoad: PropTypes.func,
  order: PropTypes.string,
  layout: PropTypes.string,
  products: PropTypes.array,
  total: PropTypes.number
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductsDisplay)
